import { sample } from "lodash";
export default function generateRandomString(length = 20) {
    return Array.from({ length })
        .map(() => sample("abcdefghijklmnopqrstuvwxyz"))
        .join("");
}
//# sourceMappingURL=generateRandomString.js.map